// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideExperienceProgressBar_main__xstoj {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    padding: 0 10px;
    padding-bottom: 5px;
}

.SideExperienceProgressBar_main_evenly__EsK\\+C {
    justify-content: space-evenly;
    align-items: center;
    padding-bottom: 0px;
}

.SideExperienceProgressBar_lv_n_icon__KYs-a {
    width: 23px;
    height: 23px;
}

.SideExperienceProgressBar_grade__XJLJe,
.SideExperienceProgressBar_experience__VmDqY {
    font-size: 12px;
    color: #c1c1c1;
}

.SideExperienceProgressBar_experience__VmDqY {
    width: auto;
}

.SideExperienceProgressBar_progress_box__3SaLL {
    min-width: 35%;
    max-width: 45%;
}

.SideExperienceProgressBar_progress_trail__ryLmJ {
    position: relative;
    width: 100%;
    height: 10px;
    background-color: #e5e5e5;
    border-radius: 4px;
}

.SideExperienceProgressBar_progress_stroke__mGIK3 {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    padding: 2px 5px 0px 5px;
    background-color: #3caae6;
    border-radius: 4px;
}

.SideExperienceProgressBar_progress_stroke_white__ipEGV {
    width: 100%;
    height: 50%;
    background-color: #63bbeb;
    border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/SideExperienceProgressBar/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB","sourcesContent":[".main {\n    width: 100%;\n    height: 40px;\n    display: flex;\n    justify-content: space-around;\n    align-items: flex-end;\n    padding: 0 10px;\n    padding-bottom: 5px;\n}\n\n.main_evenly {\n    justify-content: space-evenly;\n    align-items: center;\n    padding-bottom: 0px;\n}\n\n.lv_n_icon {\n    width: 23px;\n    height: 23px;\n}\n\n.grade,\n.experience {\n    font-size: 12px;\n    color: #c1c1c1;\n}\n\n.experience {\n    width: auto;\n}\n\n.progress_box {\n    min-width: 35%;\n    max-width: 45%;\n}\n\n.progress_trail {\n    position: relative;\n    width: 100%;\n    height: 10px;\n    background-color: #e5e5e5;\n    border-radius: 4px;\n}\n\n.progress_stroke {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    padding: 2px 5px 0px 5px;\n    background-color: #3caae6;\n    border-radius: 4px;\n}\n\n.progress_stroke_white {\n    width: 100%;\n    height: 50%;\n    background-color: #63bbeb;\n    border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `SideExperienceProgressBar_main__xstoj`,
	"main_evenly": `SideExperienceProgressBar_main_evenly__EsK+C`,
	"lv_n_icon": `SideExperienceProgressBar_lv_n_icon__KYs-a`,
	"grade": `SideExperienceProgressBar_grade__XJLJe`,
	"experience": `SideExperienceProgressBar_experience__VmDqY`,
	"progress_box": `SideExperienceProgressBar_progress_box__3SaLL`,
	"progress_trail": `SideExperienceProgressBar_progress_trail__ryLmJ`,
	"progress_stroke": `SideExperienceProgressBar_progress_stroke__mGIK3`,
	"progress_stroke_white": `SideExperienceProgressBar_progress_stroke_white__ipEGV`
};
export default ___CSS_LOADER_EXPORT___;
